import React from 'react';
import './DemoModeBar.scss';
import PropTypes from 'prop-types';
import { DEMO_CLASS_GRADES } from '../../../../../constants/reading/DemoModeConstants';

const DemoModeBar = ({ exitDemoMode, setDemoClass, demoClass, isGuidedTourOn }) => {
    const handleToggleDemoOff = () => {
        exitDemoMode();
    };
    const handleGradeSelection = event => {
        const classGrade = event.currentTarget.getAttribute('data-class-grade');
        if (classGrade !== demoClass) {
            setDemoClass(classGrade);
        }
    };
    return (
        <div className="flex-center" id="demo-mode-bar">
            <div className="flex-center demo-mode-sub-bar">
                <div className="demo-mode-status">You are currently in Demo Mode</div>
                <div className="flex-row">
                    <div>{'Selected Grade: '}</div>
                    <div className="flex-row demo-grade-options">
                        {Object.entries(DEMO_CLASS_GRADES).map(([classGrade, grade]) => {
                            return (
                                <div className="flex-center demo-grade-select" key={grade}>
                                    <input
                                        checked={classGrade === demoClass}
                                        data-class-grade={classGrade}
                                        disabled={isGuidedTourOn} // disabling radio in guided tour mode
                                        onClick={handleGradeSelection}
                                        readOnly
                                        type="radio"
                                    />
                                    <div>{grade}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="flex-center">
                <div
                    role="presentation"
                    className="demo-exit-link flex-row"
                    onClick={handleToggleDemoOff}
                >
                    <i alt="Close alert" className="icon-v2-close" />
                    <div>Exit Demo</div>
                </div>
            </div>
        </div>
    );
};

DemoModeBar.defaultProps = {
    demoClass: '',
    exitDemoMode: () => {},
    setDemoClass: () => {},
    isGuidedTourOn: false,
};

DemoModeBar.propTypes = {
    demoClass: PropTypes.string,
    exitDemoMode: PropTypes.func,
    setDemoClass: PropTypes.func,
    isGuidedTourOn: PropTypes.bool,
};

export default DemoModeBar;
